var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1107 8.49749C28.8053 7.15882 27.9013 6.10282 26.752 5.74015C24.6733 5.09082 16.3333 5.09082 16.3333 5.09082C16.3333 5.09082 7.99733 5.09082 5.91467 5.74015C4.76933 6.09749 3.86533 7.15349 3.556 8.49749C3 10.9268 3 16.0002 3 16.0002C3 16.0002 3 21.0735 3.556 23.5028C3.86133 24.8415 4.76533 25.8975 5.91467 26.2602C7.99733 26.9095 16.3333 26.9095 16.3333 26.9095C16.3333 26.9095 24.6733 26.9095 26.752 26.2602C27.8973 25.9028 28.8013 24.8468 29.1107 23.5028C29.6667 21.0735 29.6667 16.0002 29.6667 16.0002C29.6667 16.0002 29.6667 10.9268 29.1107 8.49749Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6689 20L20.5969 16L13.6689 12V20Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.929a4a443957972d166fb8d035174743.svg";
export { ForwardRef as ReactComponent };